export default "__VITE_PUBLIC_ASSET__90242bf6__"